import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class AccountBalanceStore {
  root;
  balances = {};
  accountBalancesSubject;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.accountBalancesSubject = groupByFunction(
      'messageType',
      'balance',
      this.root.websocketSubject
    ).subscribe((balanceMessage) =>
      this.handleBalance(balanceMessage.balances)
    );
  };

  handleBalance = (balance) => {
    if (balance) {
      this.balances[balance.account_number] = balance;
    }
  };
}
